import { useApiData } from "../../context/ApiDataContext";
import styles from "./style.module.scss";

const CompanyProfile = () => {
  const { profile } = useApiData();

  return (
    <div
      className={styles.companyProfile}
      dangerouslySetInnerHTML={{ __html: profile?.article_content }}
    />
  );
};

export default CompanyProfile;
